import { Gauge } from "lucide-react";
import { fmtMoney } from "@/lib/api";
import { Panel, Tag } from "@/components/common";

const Row = ({ label, value, testid, strong }) => (
  <div className="flex items-center justify-between gap-4 border-b border-[#1e293b] py-2 text-sm last:border-0">
    <span className="text-slate-400">{label}</span>
    <span data-testid={testid} className={`font-mono ${strong ? "font-bold text-slate-50" : "text-slate-200"}`}>{value}</span>
  </div>
);

export const BudgetCap = ({ b }) => {
  if (!b) return null;
  const pct = b.cap_daily ? Math.min(100, (b.current_daily / b.cap_daily) * 100) : 0;
  const over = b.cap_daily && b.current_daily > b.cap_daily;
  const planned = b.existing_target_daily + b.new_campaigns_daily;
  return (
    <Panel title="Budget cap" icon={Gauge} testid="budget-cap-card" right={<Tag tone={over ? "red" : "emerald"} testid="budget-cap-status">{over ? "Over cap" : "Within cap"}</Tag>}>
      <div className="mb-4 h-2 overflow-hidden rounded bg-slate-800"><div className={`h-full ${over ? "bg-red-400" : "bg-emerald-400"}`} style={{ width: `${pct}%` }} /></div>
      <Row label="Daily cap (monthly ÷ 30.4)" value={b.cap_daily ? `${fmtMoney(b.cap_daily)}/day` : "Set monthly budget"} testid="budget-cap-daily" strong />
      <Row label="Enabled campaigns now" value={`${fmtMoney(b.current_daily)}/day`} testid="budget-current-daily" />
      <Row label="Headroom" value={b.headroom_daily != null ? `${fmtMoney(b.headroom_daily)}/day` : "—"} testid="budget-headroom" />
      <div className="cc-eyebrow mb-1 mt-4">Owner budget split</div>
      <Row label={`Old: ${b.existing_campaign} (pause)`} value={`${fmtMoney(b.existing_target_daily)}/day`} testid="budget-existing-target" />
      <Row label="New AI campaigns (shared)" value={`${fmtMoney(b.new_campaigns_daily)}/day`} testid="budget-new-daily" />
      <Row label="Planned total" value={`${fmtMoney(planned)}/day`} testid="budget-planned-total" strong />
    </Panel>
  );
};
